import { MusicNotesSimple } from '@phosphor-icons/react';

export default MusicNotesSimple;
